import React, { useState } from 'react';
import { ListGroup, Button, Row, Col, Image, Offcanvas, Form, Alert } from 'react-bootstrap';
import { Trash3Fill, Whatsapp } from 'react-bootstrap-icons';
import { useCarrito } from './CarritoContext';
import { useParams } from 'react-router-dom';
import { API } from '../../../../api/URL_API';
import axios from 'axios';
import { trackRemoveFromCart, trackInitiateCheckout } from '../../../../utils/metaPixel';
import { getTrackingData } from '../../../../utils/trakingData';

function CarUni({ show, handleClose }) {
    const {
        carrito,
        removeFromCarrito,
        increaseQuantity,
        decreaseQuantity,
        clearCarrito,
        calculateShippingCost,
        configEnvio,
        calculateCartSummary,
        configDescuento = {}
    } = useCarrito();

    const { idSucursal } = useParams();
    const [isSending, setIsSending] = useState(false);
    const [nombreCliente, setNombreCliente] = useState('');
    const [telefonoCliente, setTelefonoCliente] = useState('');
    const [validated, setValidated] = useState(false); // Estado para la validación del formulario

    const isEnvioDisabled = configEnvio?.tipoConfig === 'desable';
    let envioCosto = calculateShippingCost();
    if (isEnvioDisabled) {
        envioCosto = 0;
    }

    // Convierte un precio (string "$1,000" o número) a número.
    const parsePrice = (value) =>
        parseFloat((value === undefined || value === null ? '0' : value).toString().replace('$', '').replace(/,/g, '')) || 0;

    // Resumen del carrito: descuento global (solo productos normales) +
    // promociones especiales por categoría (paquetes). Ver CarritoContext.
    const resumen = calculateCartSummary();
    const descuento = resumen.descuento;
    const porcentajeDescuento = descuento; // Se usa para mostrar el descuento
    const totalConDescuento = resumen.totalFinal;

    // Precio unitario efectivo y subtotal por línea (mismo orden que el carrito).
    // Viene calculado desde el contexto (contempla promo y modo mayorista).
    const detalleLinea = (index, product) => {
        const det = resumen.detalle?.[index];
        if (det) return det;
        const unit = parsePrice(product.precioU);
        return { unit, subtotal: unit * (Number(product.quantity) || 1), esPromo: false, mayorista: false };
    };

    // Calcular la cantidad total de productos
    const totalProductosQuantity = carrito.reduce(
        (acc, product) => acc + (Number(product.quantity) || 1),
        0
    );

    const handleRemoveProduct = (product) => {
        trackRemoveFromCart(product);
        removeFromCarrito(product.idProducto, product.selectedColor, product.selectedSize);
    };

    const handleIncreaseQuantity = (idProducto, selectedColor, selectedSize) => {
        increaseQuantity(idProducto, selectedColor, selectedSize);
    };

    const handleDecreaseQuantity = (idProducto, selectedColor, selectedSize) => {
        decreaseQuantity(idProducto, selectedColor, selectedSize);
    };

    const handleClearCarrito = () => {
        clearCarrito();
    };

    const formatPhoneNumber = (number) => {
        const cleanedNumber = number.replace(/\D/g, '');
        return `+57${cleanedNumber}`;
    };

    // Función para formatear montos (con separador de miles)
    const formatCurrency = (amount) => {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    const handleSendPedido = async (e) => {
        if (!nombreCliente.trim() || !telefonoCliente.trim()) {
            setValidated(true);
            return;
        }

        setIsSending(true);

        // Evento Meta Pixel InitiateCheckout
        trackInitiateCheckout(totalConDescuento + envioCosto, totalProductosQuantity);

        try {
            // Determinar el tipo de pedido según la configuración de precios
            const tipoPedido = configDescuento?.tipoConfig === 'desable' || descuento !== null || resumen.hayPromo
                ? 'unidad'
                : 'distribucion';
            const pedido = {
                idCliente: 36,
                idSucursal: idSucursal ? parseInt(idSucursal) : 1,
                tipo: tipoPedido,
                creacion: new Date().toISOString().split('T')[0],
                vence: new Date(new Date().setDate(new Date().getDate())).toISOString().split('T')[0],
                costoEnvio: envioCosto,
                totalProductos: totalConDescuento,
                totalPedido: totalConDescuento + envioCosto,
                pagado: 0,
                pendiente: totalConDescuento + envioCosto,
                estado: 'pendiente',
                descuento: descuento
            };

            const detallesPedido = carrito.map((product, index) => {
                const det = detalleLinea(index, product);
                const price = Math.round(det.unit);
                const subtotal = Math.round(det.subtotal);
                console.log("handleSendPedido -> Producto:", product.idProducto, "Precio usado:", price, "Subtotal:", subtotal);
                return {
                    idProductoTienda: product.idProducto,
                    idProducto: product.referencia,
                    cantidad: product.quantity || 1,
                    subtotal: subtotal,
                    totalPedido: subtotal,
                    idColor: product.selectedColor?.id,
                    idTalla: product.selectedSize?.id,
                };
            });

            const metaTrackingData = getTrackingData();

            const payloadData = {
                pedido,
                detallesPedido,
                nombreCliente: nombreCliente.trim(),
                numeroCliente: telefonoCliente.trim(),
                metaTrackingData
            };

            console.log('Datos enviados al servidor (incluyendo Meta Tracking):', payloadData);

            const response = await axios.post(`${API}/api/pedidos/carrito`, payloadData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            clearCarrito();

            const data = response.data;
            const numeroPedido = data.numeroPedido;

            let sucursalData;
            let numeroSucursal;
            try {
                const sucursalResponse = await axios.get(`${API}/api/pedidos/sucursal/${idSucursal}`);
                sucursalData = sucursalResponse.data;
                numeroSucursal = sucursalData.numSucursal;
            } catch (error) {
                // Si falla, intenta con idSucursal 1 por defecto
                try {
                    const sucursalResponseDefault = await axios.get(`${API}/api/pedidos/sucursal/1`);
                    sucursalData = sucursalResponseDefault.data;
                    numeroSucursal = sucursalData.numSucursal;
                } catch (error2) {
                    throw new Error('Número de sucursal no disponible');
                }
            }

            const formattedNumeroSucursal = formatPhoneNumber(numeroSucursal);
            const textoEnvio = isEnvioDisabled
                ? '+ Costo de Envío'
                : (envioCosto > 0
                    ? `$${formatCurrency(envioCosto)}`
                    : '¡GRATIS!');

            let productList = 'Detalle de productos:\n\n';
            carrito.forEach((product, index) => {
                const det = detalleLinea(index, product);
                const price = Math.round(det.unit);
                const quantity = product.quantity || 1;
                const subtotal = Math.round(det.subtotal);
                const promoTag = det.esPromo ? ' (promo)' : '';
                productList += `${product.nomProducto}${promoTag} | ${quantity} | $${formatCurrency(price)} = $${formatCurrency(subtotal)}\n`;
            });
            productList += `\nTotal productos: ${totalProductosQuantity} unidades\n`;
            productList += `Subtotal: $${formatCurrency(resumen.subtotalBase)}\n`;
            if (resumen.hayPromo && resumen.ahorroPromo > 0) {
                productList += `Promoción especial: -$${formatCurrency(resumen.ahorroPromo)}\n`;
            }
            if (descuento !== null && descuento > 0) {
                productList += `Descuento (${descuento}%): -$${formatCurrency(resumen.ahorroDescuento)}\n`;
            }
            productList += `Costo del Pedido: $${formatCurrency(totalConDescuento)}\n`;
            productList += `Costo envío: ${textoEnvio}\n`;
            productList += `Total a pagar: $${formatCurrency(totalConDescuento + envioCosto)}\n`;

            const mensajeWhatsApp =
                `Hola, soy *${nombreCliente.trim()}* (Tel: ${telefonoCliente.trim()}).\n` +
                `Acabas de realizar un pedido con el número: *${numeroPedido}*.\n\n` +
                productList +
                `\nVer pedido: https://crishacaps.com/viewOrder/${numeroPedido}\n\n` +
                `Si aun no conoces el valor del envio solo dinos en que parte del pais te encuentras.`;

            const urlWhatsApp = `https://api.whatsapp.com/send?phone=${formattedNumeroSucursal}&text=${encodeURIComponent(mensajeWhatsApp)}`;

            window.location.href = urlWhatsApp;

        } catch (error) {
            console.error('Error al enviar el pedido:', error);
            alert(`Error al enviar el pedido: ${error.response?.data?.error || error.message}`);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement='end'>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title className='text1-cr fw-bold fst-italic'>Esta es tu compra 🔥</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <ListGroup variant="flush" style={{ borderRadius: '10px', marginBottom: '5px' }}>
                    {carrito.map((product, index) => {
                        const det = detalleLinea(index, product);
                        const cantidad = Number(product.quantity) || 1;
                        return (
                            <ListGroup.Item key={product.idProducto} style={{ boxShadow: '0 4px 8px rgba(43, 35, 94, 0.3), 0 6px 20px rgba(43, 35, 94, 0.3)' }}>
                                <Row>
                                    <Col xs={3} md={4}>
                                        <Image src={product.image} rounded fluid />
                                    </Col>
                                    <Col xs={4} md={6}>
                                        <span className='fw-bold text1-cr text-uppercase'>{product.nomProducto}</span>
                                        <div className="text-muted fw-bold">
                                            $ {formatCurrency(Math.round(det.unit))} <small className="fw-normal">c/u</small>
                                        </div>
                                        {cantidad > 1 && (
                                            <div className="small text-muted">
                                                Subtotal: ${formatCurrency(Math.round(det.subtotal))}
                                            </div>
                                        )}
                                        {det.esPromo && !det.mayorista && (
                                            <span className='badge bg-warning text-dark'>Promo especial</span>
                                        )}
                                    </Col>
                                    <Col xs={4} md={2} className="d-flex justify-content-end align-items-center">
                                        <Button
                                            variant='danger'
                                            className='d-flex justify-content-center align-items-center'
                                            onClick={() => handleRemoveProduct(product)}
                                        >
                                            <Trash3Fill />
                                        </Button>
                                    </Col>
                                    <div className="d-flex justify-content-between align-items-center mt-2 w-100">
                                        <Button
                                            variant="danger"
                                            className="flex-grow-0"
                                            size="sm"
                                            style={{ width: '20%' }}
                                            onClick={() => handleDecreaseQuantity(product.idProducto, product.selectedColor, product.selectedSize)}
                                        >
                                            -
                                        </Button>
                                        <span
                                            className="mx-2 text-center border"
                                            style={{
                                                flexGrow: 1,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {product.quantity || 1}
                                        </span>
                                        <Button
                                            variant="success"
                                            className="flex-grow-0"
                                            size="sm"
                                            style={{ width: '20%' }}
                                            onClick={() => handleIncreaseQuantity(product.idProducto, product.selectedColor, product.selectedSize)}
                                            disabled={product.quantity >= product.stock}
                                        >
                                            +
                                        </Button>
                                    </div>
                                </Row>
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>

                {/* Avisos de promoción: faltan unidades para completar el paquete */}
                {resumen.avisosPromo?.map((aviso, i) => (
                    <Alert key={i} variant="warning" className="py-2 px-3 my-2 small">
                        🎉 ¡Agrega <strong>{aviso.faltan}</strong> más de{' '}
                        <strong className="text-uppercase">{aviso.categorias?.join(' o ')}</strong> y
                        llévate <strong>{aviso.packSize} x ${formatCurrency(aviso.packPrice)}</strong>.
                    </Alert>
                ))}

                <div className="d-flex justify-content-between mt-3">
                    <strong className='fw-bold text1-cr'>Subtotal:</strong>
                    <strong className='fw-bold text-muted'>${formatCurrency(resumen.subtotalBase)}</strong>
                </div>

                {resumen.hayPromo && resumen.ahorroPromo > 0 && (
                    <div className="d-flex justify-content-between mt-3">
                        <strong className='fw-bold text1-cr'>Promoción especial:</strong>
                        <strong className='fw-bold text-danger'>-${formatCurrency(resumen.ahorroPromo)}</strong>
                    </div>
                )}

                {porcentajeDescuento !== null && porcentajeDescuento > 0 && (
                    <div className="d-flex justify-content-between mt-3">
                        <strong className='fw-bold text1-cr'>Descuento aplicado ({porcentajeDescuento}%):</strong>
                        <strong className='fw-bold text-danger'>-${formatCurrency(resumen.ahorroDescuento)}</strong>
                    </div>
                )}

                {resumen.normalMayorista && (
                    <div className="d-flex justify-content-between mt-3">
                        <strong className='fw-bold text1-cr'>Precio aplicado:</strong>
                        <strong className='fw-bold text-danger'>Mayorista</strong>
                    </div>
                )}

                {resumen.promoMayorista && (
                    <div className="d-flex justify-content-between mt-3">
                        <strong className='fw-bold text1-cr'>Promociones:</strong>
                        <strong className='fw-bold text-danger'>
                            {resumen.promoMayoristaPorLimite
                                ? `Precio mayorista (+${resumen.totalPromoUnits} uds)`
                                : 'Precio mayorista'}
                        </strong>
                    </div>
                )}

                <div className="d-flex justify-content-between mt-3">
                    <strong className='fw-bold text1-cr'>Envío:</strong>
                    <strong style={{ color: envioCosto > 0 ? 'inherit' : 'green' }}>
                        {isEnvioDisabled
                            ? '+ Costo de Envío'
                            : (envioCosto > 0 ? `$ ${formatCurrency(envioCosto)}` : '¡GRATIS!')}
                    </strong>
                </div>

                <div className="d-flex justify-content-between mt-3">
                    <strong className='fw-bold text1-cr'>Total a pagar:</strong>
                    <strong className='fw-bold text-dark'>${formatCurrency(totalConDescuento + envioCosto)}</strong>
                </div>

                <div className="mt-4 mb-3 p-3 bg-light rounded">
                    <Form noValidate validated={validated}>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text1-cr">Tu Nombre <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Ej. Juan Pérez"
                                value={nombreCliente}
                                onChange={(e) => setNombreCliente(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Por favor, ingresa tu nombre.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label className="fw-bold text1-cr">Tu Teléfono (WhatsApp) <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="Ej. 3001234567"
                                value={telefonoCliente}
                                onChange={(e) => setTelefonoCliente(e.target.value)}
                            />
                            <Form.Control.Feedback type="invalid">
                                Por favor, ingresa tu número de teléfono.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form>
                </div>

                {carrito.length === 0 ? (
                    <Button
                        variant='success'
                        className="mt-3 w-100 d-flex justify-content-center align-items-center"
                        disabled
                    >
                        No hay productos en el carrito
                    </Button>
                ) : (
                    <Button
                        variant='success'
                        className="mt-3 w-100 d-flex justify-content-center align-items-center"
                        onClick={handleSendPedido}
                        disabled={isSending}
                    >
                        {isSending ? 'Enviando...' : <><Whatsapp className='me-2' size={18} /> Enviar pedido</>}
                    </Button>
                )}

                <Button
                    variant='danger'
                    className='mt-2 w-100 d-flex justify-content-center align-items-center'
                    onClick={handleClearCarrito}
                >
                    <Trash3Fill /> Vaciar carrito
                </Button>
                <div className='mt-3'>
                    <p className='small text-muted text-center'>
                        Al enviar el pedido te redirigirá a WhatsApp con uno de nuestros asesores donde podrás terminar el proceso.
                    </p>
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default CarUni;
